module.exports = __webpack_public_path__ + "static/media/E83E8C.a899f163.svg";